import {
  EvidenceSectionName,
  EvidenceSectionNameMap,
  EvidenceTask,
  EvidenceTaskName,
  EvidenceTaskNameMap,
  EvidenceTaskStatus,
  EvidenceTaskType,
} from '@api/brokerCases/types';
import { EvidenceUploadAction } from './EvidenceUploadAction';
import { EvidenceShareCodeInputAction } from './EvidenceShareCodeInputAction';
import { useMemo } from 'react';

const TASK_NAMES_ALLOWING_UPLOAD_WHEN_COMPLETED: EvidenceTaskName[] = [
  EvidenceTaskNameMap.PROOF_OF_IDENTITY,
  EvidenceTaskNameMap.BANK_STATEMENT_OR_GIFTED_DEPOSIT,
  EvidenceTaskNameMap.OTHER_DOCUMENTS,
];

export interface IEvidenceItemActionListItemButtonsProps {
  sectionName: EvidenceSectionName;
  task: EvidenceTask;
  onProgressLoadingChange: (isLoading: boolean) => void;
  isUnderReview: boolean;
  hasFailedReview: boolean;
}

export const EvidenceItemActionListItemButtons = ({
  sectionName,
  task,
  onProgressLoadingChange,
  isUnderReview,
  hasFailedReview,
}: IEvidenceItemActionListItemButtonsProps) => {
  const isProofOfDepositSection = sectionName === EvidenceSectionNameMap.PROOF_OF_DEPOSIT;

  const isUploadDisabled = useMemo(() => {
    const allowsUploadWhenCompleted = TASK_NAMES_ALLOWING_UPLOAD_WHEN_COMPLETED.includes(task.name);

    if (task.status === EvidenceTaskStatus.COMPLETED && !allowsUploadWhenCompleted) {
      return true;
    }
    if (isUnderReview) {
      return true;
    }
    return false;
  }, [task.status, task.name, isUnderReview, hasFailedReview]);

  return (
    <>
      {task.payload.taskType === EvidenceTaskType.UPLOAD_FILE && (
        <EvidenceUploadAction
          caseId={task.payload.caseId}
          individualId={task.payload.individualId}
          taskId={task.id}
          showDownloadForm={task.name === EvidenceTaskNameMap.BANK_STATEMENT_OR_GIFTED_DEPOSIT}
          taskName={task.name}
          taskDocumentType={task.payload.type}
          uploadDescriptionRequired={isProofOfDepositSection}
          isUploadDisabled={isUploadDisabled}
          onProgressLoadingChange={onProgressLoadingChange}
        />
      )}
      {task.payload.taskType === EvidenceTaskType.SET_SHARE_CODE && (
        <EvidenceShareCodeInputAction
          caseId={task.payload.caseId}
          individualId={task.payload.individualId}
          taskId={task.id}
          initialCode={task.payload.shareCode}
        />
      )}
    </>
  );
};
